import React, { useEffect } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { putEvaluationType } from '../../../store/Actions/ActionEvaluationType';
import '../../../assets/styles/StylePopup.css'
import { VariableWarehouse } from './VariableWarehouse';
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang';
import { putWarehouse } from '../../../store/Actions/ActionWarehouses';
import { Form } from '../../../components/general/general-component/abstruct-component/AbstructForm';

function EditWarehouse({ arr, open, setOpen }) {
    const { mode, dispatch, navigate, langLocal } = AbstructVar();
    const { translate } = AbstructLang();
    const { state, setStateCustom, setLoad, setState } = VariableWarehouse();
    useEffect(() => {
        setState((prevState) => ({
            ...prevState,
            name: arr.name,
            city: arr.city,
            country: arr.country,
            phone_number: arr.phone_number,
            status: arr.status === true? 1 : 0,
            location: arr.location,
            notes: arr.notes,
        }));
    }, [arr]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(putWarehouse(arr.id, state.name, state.city, state.country, state.location, state.phone_number, state.notes, state.status, setLoad));
    };
    const formFields = [
        { name: 'name', label: 'name', type: 'text', inputType: 'text', iconType: "pencil" },
        { name: 'city', label: 'city', type: 'text', inputType: 'text', iconType: "city" },
        { name: 'country', label: 'country', type: 'text', inputType: 'text', iconType: "city" },
        { name: 'location', label: 'location', type: 'text', inputType: 'text', iconType: "location" },
        { name: 'phone_number', label: 'phone', type: 'number', inputType: 'text', iconType: "phone" },
        { name: 'notes', label: 'notes', type: 'text', inputType: 'text', iconType: "pencil" },
        {
            name: 'status',
            label: 'Status',
            type: 'text',
            inputType: 'one_select',
            iconType: "check",
            options: [{ value: 1, label: 'active' }, { value: 0, label: 'un active' }]
        },
    ];

    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: 'popupR',
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? 'darkPopUp' : 'lightPopUp'}`}>
                <div className={`div_title_popup ${mode === 'dark' ? 'darktoppopup' : 'lighttoppopup'}`}>
                    <p className={`title_popup ${mode === 'dark' ? 'darktext' : 'lighttext'}`}>{translate('edit-warehouse')}</p>
                </div>
                <Form langLocal={langLocal} fields={formFields} handleSubmit={handleSubmit} state={state} setStateCustom={setStateCustom} translate={translate} buttonLabel="edit" />
            </div>
        </RModal>
    );
}

export default EditWarehouse;

